/* ========================================================================
 *  module call me
 * ========================================================================
*/
FD.PAGEACCESS = (function ($, me) {
    'use strict';

    var child = me.PAGEACCESS || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_PAGEACCESS = '/Common/PageAccess/';

    var PAGEACESS_MODAL = '#PAGEACESS_MODAL';

    var modal;

    function showModal() {
        const viewID = $("#PAGEACESS_BUTTON").data("viewid");
        var options = {
            params: { viewID },
            url: URL_PAGEACCESS + 'ReturnPageAccessModal',
            callback: afterData,
            ishtml: true,
            cancelprevious: true
        };
        me.AJAX.setAJAX(options);

        function afterData(result) {
            modal = $(PAGEACESS_MODAL);

            modal.html(result.data).enableControls();
            modal.modal('show');
        }
    }

    //  set after control event
    //  handle all interface events here
    function setAfterControlEvent(data) {

    }


    //  init
    child.showModal = showModal;


    //   after control event
    child.getAfterControlEvent = function (data) {
        setAfterControlEvent(data);
    };

    return child;
}(jQuery, FD));



